import { useSelector } from 'react-redux';
import { selectRegionId } from '../selectors/offer';
import { EMultiPostingAvailablePlatforms, IMultiPostingPlatformsByRegion } from '../types/reducers/multiPosting';
import { useAppContext } from '../../AppModulesWrapper';
import { selectMultiPostingAvailablePlatforms } from '../selectors/publishTerms';

export const useMultiPostingDescription = (): string => {
  const { config } = useAppContext();
  const availablePlatforms = useSelector(selectMultiPostingAvailablePlatforms);
  const regionId = useSelector(selectRegionId);
  const platformsByRegion = config.get<IMultiPostingPlatformsByRegion>('addformConfig.multiPosting.platforms') || {};
  const regionData = platformsByRegion[String(regionId)];
  const defaultText = String(config.get('addformConfig.multiPosting.text'));

  if (!regionData) {
    return defaultText;
  }

  const { descriptionAll, descriptionFree } = regionData;

  if (availablePlatforms === EMultiPostingAvailablePlatforms.Free && descriptionFree) {
    return descriptionFree;
  } else if (availablePlatforms === EMultiPostingAvailablePlatforms.All && descriptionAll) {
    return descriptionAll;
  }

  return defaultText;
};
